export const ROUTE_LABELS: Record<string, string> = {
  'engineering-dashboard': 'Engineering Dashboard',
  'internal-motor-selection': 'Internal Motor Selection',
  'available-alternatives': 'Available Alternatives',
  'comparison-report': 'Comparison Report',
  'external-investigation': 'External Investigation',
  'home': 'Home',
  'results': 'Results',
  'approval-tasks': 'Approval Tasks',
  'investigation-list': 'Investigation List',
};

export interface RouteHierarchyConfig {
  segments: string[];
  routePatterns: Record<string, string>;
  parameterMappings?: Record<string, string[]>;
}

export const ROUTE_HIERARCHIES: Record<string, RouteHierarchyConfig> = {
  
  // Engineering Dashboard flow: Dashboard > Internal Motor Search > Available Alternatives
  '/engineering-dashboard/available-alternatives': {
    segments: ['engineering-dashboard', 'internal-motor-selection', 'available-alternatives'],
    routePatterns: {
      'engineering-dashboard': '/engineering-dashboard',
      'internal-motor-selection':
        '/engineering-dashboard/internal-motor-selection/:investigationTicketId/:oldMotorNumber/:childTicket',
      'available-alternatives':
        '/engineering-dashboard/available-alternatives/:investigationTicketId/:oldMotorNumber/:childTicket/:investigationFlowId',
    },
    parameterMappings: {
      'internal-motor-selection': ['investigationTicketId', 'oldMotorNumber', 'childTicket'],
      'available-alternatives': [
        'investigationTicketId',
        'oldMotorNumber',
        'childTicket',
        'investigationFlowId',
      ],
    },
  },

  // Approval Tasks flow: Approval Tasks > Part Number
  '/approval-tasks': {
    segments: ['approval-tasks', ':partNumber'],
    routePatterns: {
      'approval-tasks': '/approval-tasks',
      ':partNumber': '/approval-tasks/:partNumber/:ticketId/:investigationFlowId',
    },
    parameterMappings: {
      ':partNumber': ['partNumber', 'ticketId', 'investigationFlowId'],
    },
  },

  // Investigation List flow: Investigation List > Old Motor PN
  '/investigation-list': {
    segments: ['investigation-list', ':oldMotorPn'],
    routePatterns: {
      'investigation-list': '/investigation-list',
      ':oldMotorPn': '/investigation-list/:oldMotorPn',
    },
    parameterMappings: {
      ':oldMotorPn': ['oldMotorPn'],
    },
  },

  // Motor List flow: Motor List > Article Number
  '/motor-list': {
    segments: ['motor-list', ':articleNumber'],
    routePatterns: {
      'motor-list': '/motor-list',
      ':articleNumber': '/motor-list/:articleNumber',
    },
    parameterMappings: {
      ':articleNumber': ['articleNumber'],
    },
  },

  // Engineering Dashboard flow: Dashboard > Internal Motor Search > Available Alternatives > Comparison Report
  '/engineering-dashboard/comparison-report': {
    segments: ['engineering-dashboard', 'internal-motor-selection', 'available-alternatives','comparison-report'],
    routePatterns: {
      'engineering-dashboard': '/engineering-dashboard',
      'internal-motor-selection':
        '/engineering-dashboard/internal-motor-selection/:investigationTicketId/:oldMotorNumber/:childTicket',
      'available-alternatives':
        '/engineering-dashboard/available-alternatives/:investigationTicketId/:oldMotorNumber/:childTicket/:investigationFlowId',
      'comparison-report':
        '/engineering-dashboard/comparison-report/:investigationTicketId/:oldMotorNumber/:childTicket/:investigationFlowId',
    },
    parameterMappings: {
      'internal-motor-selection': ['investigationTicketId', 'oldMotorNumber', 'childTicket'],
      'available-alternatives': [
        'investigationTicketId',
        'oldMotorNumber',
        'childTicket',
        'investigationFlowId',
      ],
      'comparison-report': [
        'investigationTicketId',
        'oldMotorNumber',
        'childTicket',
        'investigationFlowId',
      ],
    },
  },

  // Engineering Dashboard flow: Dashboard > Internal Motor Search > Available Alternatives > External Investigation
  '/engineering-dashboard/external-investigation/comparison-report': {
    segments: ['engineering-dashboard', 'external-investigation', 'comparison-report'],
    routePatterns: {
      'engineering-dashboard': '/engineering-dashboard',
      'external-investigation':
        '/engineering-dashboard/external-investigation/:investigationTicketId/:oldMotorNumber/:childTicket/:investigationFlowId',
      'comparison-report':
         '/engineering-dashboard/external-investigation/comparison-report/:investigationTicketId/:oldMotorNumber/:childTicket/:investigationFlowId',
    },
    parameterMappings: {
       'external-investigation': [
        'investigationTicketId',
        'oldMotorNumber',
        'childTicket',
        'investigationFlowId',
      ],
        'comparison-report': [
        'investigationTicketId',
        'oldMotorNumber',
        'childTicket',
        'investigationFlowId',
      ],
    },
  },

  // Engineering Dashboard flow: Dashboard > Internal Motor Search > External Investigation
  '/engineering-dashboard/external-investigation/comparison-report:from-external': {
    segments: ['engineering-dashboard', 'external-investigation', 'comparison-report'],
    routePatterns: {
      'engineering-dashboard': '/engineering-dashboard',
      'external-investigation':
        '/engineering-dashboard/external-investigation/:investigationTicketId/:oldMotorNumber/:childTicket/:investigationFlowId',
      'comparison-report':
        '/engineering-dashboard/external-investigation/comparison-report/:investigationTicketId/:oldMotorNumber/:childTicket/:investigationFlowId',
    },
    parameterMappings: {
      'external-investigation': [
        'investigationTicketId',
        'oldMotorNumber',
        'childTicket',
        'investigationFlowId',
      ],
    'comparison-report': [
      'investigationTicketId',
      'oldMotorNumber',
      'childTicket',
      'investigationFlowId',
    ],
  },
}
};
